<template>
  <div class="pc-login-container">
    <div class="inner-container">
      <div class="left-item img-cover">
        <img src="../assets/pc-images/login-bg.jpg" />
      </div>
      <div class="right-item">
        <div class="title-item">
          <span class="title" v-if="pageType == 'login'">登录</span>
          <span class="title" v-if="pageType == 'register'">注册</span>
          <span class="title" v-if="pageType == 'forget'">忘记密码</span>
          <div class="back-btn" v-if="pageType != 'login'" @click="pageType = 'login'"><img class="icon" src="../assets/pc-images/back-blue-icon.png" /> 返回登录</div>
        </div>
        <div class="subtitle-item">{{ websiteInfo.SiteName }}</div>
        <div class="input-list-item">
          <template v-if="pageType == 'login'">
            <div class="input-item">
              <img src="../assets/pc-images/username-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.UserName" type="text" placeholder="请输入您的手机号/用户名" />
              </div>
            </div>
            <div class="input-item">
              <img src="../assets/pc-images/pwd-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.Pwd" type="password" placeholder="请输入您的密码" />
              </div>
            </div>
            <div class="input-2-item">
              <div class="input-item">
                <img src="../assets/pc-images/code-icon.png" class="icon" />
                <div class="input">
                  <input v-model="from.CaptchaValue" type="text" placeholder="请输入验证码" />
                </div>
              </div>
              <div class="code-item img-cover">
                <img :src="captchaPath" @click="handleGetCaptcha" />
              </div>
            </div>
            <div class="to-forget-item">
              <div class="btn" @click="pageType = 'forget'">忘记密码？</div>
            </div>
            <div class="submit-btn" @click="handleLogin">
              <van-loading v-if="submiting" color="#ffffff" />
              <span v-else>登录</span>
            </div>
            <div v-if="showRegister" class="to-register-item">
              <div class="btn" @click="pageType = 'register'">注册账号</div>
            </div>
          </template>
          <template v-if="pageType == 'register'">
            <div class="input-item">
              <img src="../assets/pc-images/username-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.UserName" type="text" placeholder="请输入您的手机号/用户名" />
              </div>
            </div>
            <div class="input-item">
              <img src="../assets/pc-images/phone-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.Phone" type="text" placeholder="请输入您的手机号" />
              </div>
            </div>
            <div v-if="showZcYzm" class="input-2-item">
              <div class="input-item">
                <img src="../assets/pc-images/code-icon.png" class="icon" />
                <div class="input">
                  <input v-model="from.CaptchaValue" type="text" placeholder="请输入验证码" />
                </div>
              </div>
              <div class="code-item img-cover">
                <img :src="captchaPath" @click="handleGetCaptcha" />
              </div>
            </div>
            <div v-if="showZcYzm" class="input-2-item">
              <div class="input-item">
                <img src="../assets/pc-images/code-icon.png" class="icon" />
                <div class="input">
                  <input v-model="from.Vcode" type="text" placeholder="请输入短信验证码" />
                </div>
              </div>
              <div class="sms-code-item" :class="time > 0 ? 'not' : ''" @click="getMsg">{{ time > 0 ? time + 's' : '获取验证码' }}</div>
            </div>
            <div class="input-item">
              <img src="../assets/pc-images/pwd-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.Pwd" type="password" placeholder="请输入密码" />
              </div>
            </div>
            <div class="input-item">
              <img src="../assets/pc-images/pwd-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.SurePwd" type="password" placeholder="请确认密码" />
              </div>
            </div>
            <div v-if="showYqm" class="input-item">
              <img src="../assets/pc-images/code-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.Yqm" type="text" placeholder="请输入邀请码" />
              </div>
            </div>
            <div class="submit-btn" @click="handleRegist">
              <van-loading v-if="submiting" color="#ffffff" />
              <span v-else>注册</span>
            </div>
          </template>
          <template v-if="pageType == 'forget'">
            <div class="input-item">
              <img src="../assets/pc-images/phone-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.Phone" type="text" placeholder="请输入您的手机号" />
              </div>
            </div>
            <div class="input-2-item">
              <div class="input-item">
                <img src="../assets/pc-images/code-icon.png" class="icon" />
                <div class="input">
                  <input v-model="from.CaptchaValue" type="text" placeholder="请输入验证码" />
                </div>
              </div>
              <div class="code-item img-cover">
                <img :src="captchaPath" @click="handleGetCaptcha" />
              </div>
            </div>
            <div class="input-2-item">
              <div class="input-item">
                <img src="../assets/pc-images/code-icon.png" class="icon" />
                <div class="input">
                  <input v-model="from.Vcode" type="text" placeholder="请输入短信验证码" />
                </div>
              </div>
              <div class="sms-code-item" :class="time > 0 ? 'not' : ''" @click="getMsg">{{ time > 0 ? time + 's' : '获取验证码' }}</div>
            </div>
            <div class="input-item">
              <img src="../assets/pc-images/pwd-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.Pwd" type="password" placeholder="请输入密码" />
              </div>
            </div>
            <div class="input-item">
              <img src="../assets/pc-images/pwd-icon.png" class="icon" />
              <div class="input">
                <input v-model="from.SurePwd" type="password" placeholder="请确认密码" />
              </div>
            </div>
            <div class="submit-btn" @click="handleForget">
              <van-loading v-if="submiting" color="#ffffff" />
              <span v-else>确认修改</span>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
export default {
  emits: ['onLoginSuccess'],
  name: 'PcLoginComponent',
  props: {
    type: {
      type: String,
      default: "login", // login: 登录, register: 注册, forget: 忘记密码,
    },
  },
  computed: {
    ...mapState(['websiteInfo']),
  },
  data() {
    return {
      pageType: '',
      captchaPath: '',
      submiting: false,
      showRegister: false,
      showYqm: false,
      showZcYzm: false,
      from: {
        UserName: '',
        Pwd: '',
        CaptchaValue: '',

        Phone: '',
        ZcYqm: '',
        SurePwd: '',
        Yqm: '',
        
        Vcode: '',
      },
      time: 0,
      timer: null
    }
  },
  watch: {
    pageType(val) {
      if (val == 'login') {
        this.handleGetCaptcha()
        this.handleGetLoginSetting()
      }
      if (val == 'register') {
        this.handleGetRegisterSetting()
      }
      const from = {}
      for (const key in this.from) {
        from[key] = ''
      }
      this.from = from
    }
  },
  created() {
    this.pageType = this.type
  },
  methods: {
    ...mapMutations(['SET_TOKEN']),
    ...mapActions(['GetUserInfo']),
    async handleGetLoginSetting() {
      var res = await this.$API.getSet.post({
        Key: 'is_register'
      })
      this.showRegister = res.info == 1
    },
    async handleGetRegisterSetting() {
      var res = await this.$API.getSets.post({
        Key: 'is_yqm,is_zc_yzm'
      })
      this.showYqm = res.is_yqm == 1
      this.showZcYzm = res.is_zc_yzm == 1
      if (res.is_zc_yzm == 1) {
        this.handleGetCaptcha()
      }
    },
    handleGetCaptcha() {
      this.captchaPath = this.$HTTP.baseURL + '/common/captcha?v=' + (new Date().getTime())
    },
    async getMsg() {
      const { from, time, timer } = this
      if (time > 0 || timer != null) {
        return
      }
      if (!from.Phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!from.CaptchaValue) {
        this.$toast('请输入图形验证码')
        return
      }
      var res = await this.$API.sendMsg.post({
        Phone: from.Phone,
        CaptchaValue: from.CaptchaValue,
      })
      if (res.error == 0) {
        this.setTimer()
      } else {
        this.$dialog.alert({
          type: 'danger',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
        this.handleGetCaptcha()
      }
    },
    setTimer() {
      if (this.timer != null) {
        clearInterval(this.timer)
      }
      let t = 60
      this.time = t
      this.timer = setInterval(() => {
        t--
        this.time = t
        if (t <= 0) {
          clearInterval(this.timer)
        }
      }, 1000);
    },
    async handleLogin() {
      const { from } = this
      if (!from.UserName) {
        this.$toast('请输入您的手机号/用户名')
        return
      }
      if (!from.Pwd) {
        this.$toast('请输入您的密码')
        return
      }
      if (!from.CaptchaValue) {
        this.$toast('请输入验证码')
        return
      }
      this.submiting = true
      var res = await this.$API.login.post(from)
      this.submiting = false
      if (res.error == 0) {
        this.SET_TOKEN(res.info)
        var user = await this.GetUserInfo()
        if (user.error == 0) {
          this.$emit('onLoginSuccess')
        } else {
          this.$dialog.alert({
            type: 'danger',
            className: 'pc-dialog z-index9999',
            title: '提示',
            message: user.info,
            confirmButtonText: '确定'
          })
          this.handleGetCaptcha()
        }
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog z-index9999',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定'
        })
        this.handleGetCaptcha()
      }
    },
    async handleRegist() {
      const { from, showYqm, showZcYzm } = this
      if (!from.UserName) {
        this.$toast('请输入您的手机号/用户名')
        return
      }
      if (!from.Phone) {
        this.$toast('请输入您的手机号')
        return
      }
      if (showZcYzm && !from.ZcYqm) {
        this.$toast('请输入短信验证码')
        return
      }
      if (!from.Pwd) {
        this.$toast('请输入您的密码')
        return
      }
      if (!from.SurePwd) {
        this.$toast('请输入确认密码')
        return
      }
      if (from.Pwd != from.SurePwd) {
        this.$toast('两次输入密码不一致')
        return
      }
      if (!showYqm || !from.Yqm) {
        delete from.Yqm
      }
      this.submiting = true
      var res = await this.$API.register.post(from)
      this.submiting = false
      if (res.error == 0) {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog z-index9999',
          title: '提示',
          message: res.info,
          confirmButtonText: '去登录'
        }).then(() => {
          this.pageType = 'login'
        })
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog z-index9999',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    },
    async handleForget() {
      const { from } = this
      if (!from.Phone) {
        this.$toast('请输入手机号')
        return
      }
      if (!from.Vcode) {
        this.$toast('请输入验证码')
        return
      }
      if (!from.Pwd) {
        this.$toast('请输入新密码')
        return
      }
      if (from.Pwd.length < 6 || from.Pwd.length > 20) {
        this.$toast('请设置6-20位密码')
        return
      }
      if (!from.SurePwd) {
        this.$toast('请再次输入新密码')
        return
      }
      if (from.SurePwd.length < 6 || from.SurePwd.length > 20) {
        this.$toast('请设置6-20位密码')
        return
      }
      if (from.Pwd != from.SurePwd) {
        this.$toast('两次输入密码不一致')
        return
      }
      this.submiting = true
      var res = await this.$API.forgetPwd.post({
        Phone: from.Phone,
        Code: from.Vcode,
        Pwd: from.Pwd,
      })
      this.submiting = false
      if (res.error == 0) {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog z-index9999',
          title: '提示',
          message: res.info,
          confirmButtonText: '去登录'
        }).then(() => {
          this.pageType = 'login'
        })
      } else {
        this.$dialog.alert({
          type: 'danger',
          className: 'pc-dialog z-index9999',
          title: '提示',
          message: res.info,
          confirmButtonText: '确定',
        })
      }
    },
  }
}
</script>

<style scoped lang="less">
.pc-login-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .inner-container {
    box-sizing: border-box;
    width: 750px;
    min-height: 410px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left-item {
      width: 365px;
      align-self: stretch;
    }
    .right-item {
      padding: 20px 0;
      color: #1d2129;
      flex: 1;
      margin-left: 30px;
      .title-item {
        height: 35px;
        display: flex;
        align-items: center;
        .title {
          font-size: 24px;
          font-weight: 500;
        }
        .back-btn {
          margin-left: 15px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .icon {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }
        }
      }
      .subtitle-item {
        margin-top: 5px;
        height: 20px;
        line-height: 20px;
        color: #86909c;
      }
      .input-list-item {
        width: 320px;
        padding-top: 25px;
        .input-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 35px;
          background-color: #f2f3f5;
          border-radius: 2px;
          margin-bottom: 15px;
          .icon {
            width: 16px;
            height: 16px;
            margin: 0 12px;
          }
          .input {
            height: 20px;
            flex: 1;
            margin-right: 12px;
          }
        }
        .input-2-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          .input-item {
            flex: 1;
            width: auto;
            margin-right: 15px;
            margin-bottom: 0;
          }
          .code-item {
            width: 100px;
            height: 35px;
            border-radius: 2px;
            cursor: pointer;
            background-color: #f2f3f5;
          }
          .sms-code-item {
            width: 130px;
            height: 35px;
            background-color: #5783fc;
            color: #fff;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 13px;
            cursor: pointer;
            &.not {
              background-color: #f2f3f5;
              cursor: none;
            }
          }
        }
        .to-forget-item {
          width: 100%;
          height: 21px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-bottom: 15px;
          .btn {
            cursor: pointer;
            color: #5783fc;
          }
        }
        .submit-btn {
          background-color: #5783fc;
          color: #fff;
          width: 100%;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          cursor: pointer;
        }
        .to-register-item {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
          .btn {
            cursor: pointer;
            color: #8a94a0;
            font-size: 13px;
            line-height: 19px;
          }
        }
      }
    }
  }
}
</style>